export const descriptionCount = {
    textAlign: "right",
    color: "red"
};
